var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _vm.imageable.length === 1
        ? _c(
            "figure",
            {
              staticClass: "c-carousel",
              on: {
                click: function($event) {
                  return _vm.$emit("open")
                }
              }
            },
            [
              _vm.imageable[0].image_id
                ? _c("ResponsiveImage", {
                    attrs: {
                      id: _vm.imageable[0].image_id,
                      css: "c-carousel__image c-carousel__image--center"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.imageable[0].image_id
                ? _c("ImageCaption", {
                    attrs: {
                      id: _vm.imageable[0].image_id,
                      css: "c-carousel__caption"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm.imageable.length > 1
        ? _c("carousel", { attrs: { residence_id: _vm.residence_id } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }